import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { TagModule } from 'primeng/tag';

@Component({
  selector: 'ces-campaign-tags',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TagModule, TranslocoModule],
  host: { class: 'contents' },
  templateUrl: './ces-campaign-tags.component.html',
})
export class CesCampaignTagsComponent {
  readonly hasPendingConflicts = input(false);
  readonly hasImportedData = input(false);
  readonly resolveConflicts = output<void>();
}
